module.exports = __webpack_public_path__ + "img/grin-tongue.e67874c3.svg";